import React, { useEffect, useState } from 'react';
import { HeaderFacilities } from '../../../Components/HeaderFacilities';
import Botaofacilities from '../../../Components/BotaoFacilities';
import { useGlobal } from '../../../GlobalContext';
import './style.css';

const { REACT_APP_URL_API } = process.env;
const STORAGE_KEY = 'propaganda_vista';
const CINCO_DIAS_MS = 5 * 24 * 60 * 60 * 1000;

const FacilitiesHome = () => {
  const { data } = useGlobal();
  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    if (!data?.cliente?.status_propaganda || !data?.cliente?.img_propaganda) return;
    const imgAtual = data.cliente.img_propaganda;
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) {
        const { imagem, visto_em } = JSON.parse(raw);
        if (imagem === imgAtual && Date.now() - visto_em <= CINCO_DIAS_MS) return;
        localStorage.removeItem(STORAGE_KEY);
      }
    } catch { localStorage.removeItem(STORAGE_KEY); }
    setShowModal(true);
  }, [data]);
  const handleFechar = () => { const imgAtual = data?.cliente?.img_propaganda; if (imgAtual) localStorage.setItem(STORAGE_KEY, JSON.stringify({ imagem: imgAtual, visto_em: Date.now() })); setShowModal(false); };
  const cliente = data?.cliente || {};
  return <div><HeaderFacilities /><div className="MainGrid"><div className="firstColumn"><div className="box" /> <div className="box" style={{ margin: '10px auto', border: 'none', background: 'var(--background-main)' }}><Botaofacilities /></div></div></div>{showModal && cliente.img_propaganda && <div className="home-ad-modal" onClick={handleFechar}><div className="home-ad-modal__content" onClick={(event) => event.stopPropagation()}><img src={`${REACT_APP_URL_API}${cliente.img_propaganda}`} alt="Propaganda" /><button onClick={handleFechar} aria-label="Fechar propaganda">×</button></div></div>}</div>;
};
export default FacilitiesHome;
